'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { useFieldContext } from './FieldContext';
/**
 * For a group control inside a <Field> — a set of pills, a radio group, a
 * block of related inputs — that a `<label for>` cannot name. Returns the
 * attributes for the group element: aria-labelledby (the Field label),
 * aria-describedby (description, then error) and aria-invalid. Calling it
 * tells the Field the label names a group, so the label drops its `for`,
 * says "required" in words (aria-required is not allowed on role="group"),
 * and Field.Control steps aside. Outside a Field it returns nothing.
 */
export function useFieldLabelling() {
    const ctx = useFieldContext();
    const register = ctx?.registerPart;
    useLayoutEffect(() => register?.('group'), [register]);
    if (!ctx)
        return {};
    return {
        ...(ctx.labelledBy !== undefined ? { 'aria-labelledby': ctx.labelledBy } : {}),
        ...(ctx.describedBy !== undefined ? { 'aria-describedby': ctx.describedBy } : {}),
        ...(ctx.invalid ? { 'aria-invalid': true } : {}),
    };
}
/**
 * Compound member of <Field> for a field whose content is several controls
 * rather than one input: a role="group" named and described by the Field.
 *
 * <Field>
 *   <Field.Label>Social links</Field.Label>
 *   <Field.Group>
 *     <Field label="Website"><Input /></Field>
 *     <Field label="LinkedIn"><Input /></Field>
 *   </Field.Group>
 * </Field>
 */
export function FieldGroup({ children }) {
    const labelling = useFieldLabelling();
    return (_jsx("div", { role: "group", ...labelling, children: children }));
}
//# sourceMappingURL=FieldGroup.js.map